import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { canAccess } from "@/lib/roles";

export default function RequireAuth() {
  const { user, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background-100">
        <div className="w-10 h-10 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
        <p className="mt-4 text-sm text-foreground-600">Loading administration…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (user.status === "locked") {
    return <Navigate to="/admin/login" replace />;
  }

  // Role-based route guard: if the role can't open this page, send them home.
  if (!canAccess(user.role, location.pathname)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
}